import styled from 'styled-components';

export const Wrapper = styled.div<{ left: number | string }>`
  border: 1px solid #ddd;
  position: absolute;
  left: ${(props => props.left)}px;
  top: 15px;
  bottom: 20px;
  width: 1px;
`;
